<template>
  <div class="video_agreement">
    <div class="inner_wrapper">
      <div v-if="interview.company && !!interview.company.logo" class="logo">
        <img :src="interview.company.logo" alt="vcv" />
      </div>

      <div>
        <div class="info-text">
          <div class="info-title">{{ surveyModule.name }}</div>
          <div class="info-desc">{{ surveyModule.description }}</div>
        </div>

        <vbutton :label="$tr('interview.tests.init.button.start')" @click="$emit('input', true)" />

        <agree-text-index class="video_agreement__agreement" />
      </div>
    </div>
  </div>
</template>

<script>
  import AgreeTextIndex from '@/routes_new/outer/interview/landing/components/agree-text';

  export default {
    name: 'Agreement',

    components: {
      AgreeTextIndex
    },

    props: {
      interview: {
        type: [Object, Array],
        default: () => {}
      }
    },

    computed: {
      surveyModule() {
        if (this.interview.active_modules !== undefined) {
          const survey = this.interview.active_modules.find(i => i.id === 'survey');

          return {
            name: survey.name ? survey.name : '',
            description: survey.description ? survey.description : ''
          };
        } else {
          return { name: '', description: '' };
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .video_agreement {
    background-color: #e5e5e5;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 2vw 0;
    min-width: 320px;

    .inner_wrapper {
      position: relative;
      background-color: #fff;
      max-width: 800px;
      padding: 35px 5vw;
      box-sizing: border-box;
      margin: auto 0;
      min-width: 320px;
      width: 100%;
    }

    &__agreement {
      margin-top: 15px;
    }
  }

  .flex_center {
    display: flex;
    align-items: center;
  }

  .margin_right {
    margin-right: 10px;
  }

  .logo {
    height: 60px;
    max-height: 60px;
    min-height: 60px;
    margin-bottom: 30px;

    img {
      height: 100%;
    }
  }

  .info-text {
    margin-bottom: 30px;

    .info-title {
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      font-size: 28px;
      margin-bottom: 30px;
    }

    .description {
      font-style: normal;
      font-weight: normal;
      line-height: 22px;
      font-size: 15px;
    }
  }
</style>
